import { useMutation } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useTranslation } from 'libs/i18n'
import { apiRoutes } from 'config/apiRoutes'

export const useRequestPayoutMutation = (onSettled: () => void) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: requestPayoutMutation } = useMutation({
		mutationFn: ({ checkedSales }: { checkedSales: number[] }) => {
			return axiosPrivate.post(apiRoutes.salesRequestPayout, { ids: checkedSales })
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Requesting payout succeeded')
			})()
		},
		onError: (err: any) => {
			useToast({
				type: 'error',
				message: err.response?.data?.detail ?? t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		requestPayoutMutation
	}
}
